import { BaseActionPointDTO } from "../action-points-configuration.model";
import { ActionPointType } from "../_enum/action-point.enum";

export class DialogActionPointsData {
    public actionPointType: ActionPointType;
    public actionPointData: BaseActionPointDTO[];
    public campaignSequence : number;

    constructor(actionPointType: ActionPointType, actionPointData: BaseActionPointDTO[], campaignSequence : number){
        this.actionPointType = actionPointType;
        this.actionPointData = actionPointData;
        this.campaignSequence = campaignSequence;
    }
}
